import secondaryComponents from "../..";
import { PurchaseOrderImage } from "../../../../assets/svgImages";
import { WarningDialog } from "../../../common";
import { useBillsExtra } from "../BillsExtra/useBillsExtra";
import { useBillsTable } from "./useBillsTable";

export const BillsTable = ({ bills, metaDetails, gotoPage = () => {} }) => {
  const { instance, selectedBillsDetails, setSelectedBillsDetails } =
    useBillsTable({
      bills,
    });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  const { isDeletingBills, handleDeleteBills } = useBillsExtra({
    closeModal: () => setSelectedBillsDetails(null),
  });

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="pt-5 text-center">
          <PurchaseOrderImage />
          <h4>You have no Bills </h4>
          <p>
            Use the button above to create a bill When you do, they would appear
            here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {bills?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.Modal
        isActive={!!selectedBillsDetails}
        width={550}
        closeModal={() => setSelectedBillsDetails(null)}
      >
        <WarningDialog
          title={`Delete Bill: ${selectedBillsDetails?.bill_number}`}
          closeModal={() => setSelectedBillsDetails(null)}
          handler={() => handleDeleteBills(selectedBillsDetails)}
          isLoading={isDeletingBills}
        >
          <p>
            Supplier:{" "}
            <span className="dark--text">
              {selectedBillsDetails?.supplier?.name}
            </span>
          </p>
          <p>
            Bill Number:{" "}
            <span className="dark--text">
              {selectedBillsDetails?.bill_number}
            </span>
          </p>
        </WarningDialog>
      </secondaryComponents.Modal>
    </>
  );
};
